import { useHistory } from 'react-router-dom'

import { hasShipperInformation } from 'core/domain/Shipper'
import useWindowWidth from 'core/ui/hooks/useWindowWidth'

import { intSizes } from 'legacy/styles/screen'

import { isQuoteExpired } from '../domain/Quote'
import { isSingleQuote, type SpotQuoteListItem } from '../domain/SpotQuoteListItem'
import { isSoonestBidDeadlineExpired } from '../domain/SpotQuoteListLanes'
import { BulkSpotQuoteDesktopCard } from './BulkSpotQuoteDesktopCard'
import { BulkSpotQuoteMobileCard } from './BulkSpotQuoteMobileCard'
import { SingleSpotQuoteDesktopCard } from './SingleSpotQuoteDesktopCard'
import { SingleSpotQuoteMobileCard } from './SingleSpotQuoteMobileCard'

export type SpotQuoteCardProps = {
  expiredQuote: boolean
  item: SpotQuoteListItem
  showDeadline: boolean
  showShipper?: boolean
  onBidClick: () => void
}

export function SpotQuoteCard({ item }: { item: SpotQuoteListItem }) {
  const isSingle = isSingleQuote(item)
  const { push: navigate } = useHistory()

  const { isUnderNegotiation, lanes, shipper, type } = item
  const [{ uuid: singleQuoteUuid, quote }] = lanes.rates
  const { uuid: bulkQuoteUuid } = lanes
  const parsedUuid = isSingle ? singleQuoteUuid : bulkQuoteUuid

  const isExpiredQuote = isSingle ? isQuoteExpired(quote) : isSoonestBidDeadlineExpired(lanes)
  const hasShipperInfo = hasShipperInformation(shipper)
  const shouldShowDeadline = isUnderNegotiation ? !isExpiredQuote : true

  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= intSizes.md

  function handleOnBidClick() {
    navigate(`/all-in-one/bids/spot-quote/${parsedUuid}/${type}`)
  }

  let Component = isSingle ? SingleSpotQuoteDesktopCard : BulkSpotQuoteDesktopCard

  if (isSingle) {
    if (isMobile) Component = SingleSpotQuoteMobileCard
  } else {
    if (isMobile) Component = BulkSpotQuoteMobileCard
  }

  return (
    <Component
      showShipper={hasShipperInfo}
      expiredQuote={isExpiredQuote}
      item={item}
      showDeadline={shouldShowDeadline}
      onBidClick={handleOnBidClick}
    />
  )
}
